import React, { FC, useState, useEffect } from 'react';
import { StyledHero } from './Hero.styles';
import { HeroProps } from './Hero.types';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import playBtn from '../../../assets/images/lovetravels/alt-play.svg';
import Image from 'next/image';
import { VideoDialog } from './VideoDialog';

export const HeroWrapperConfig = {
  emptyLabel: 'LT Hero',
  isEmpty: false,
  resourceType: 'mi-aem-martech/components/lovetravels/hero',
};

export const HeroComp: FC<HeroProps> = (props: HeroProps) => {
  const { model } = props;
  const [showModal, setShowModal] = useState(false);
  const [isFontLoaded, setIsFontLoaded] = useState(false);

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.fonts.ready.then(() => {
        setIsFontLoaded(true);
      });
    }
  }, []);

  return (
    <StyledHero id="lt-hero-wrapper-container" data-testid="lt-hero">
      <section
        className="lt-hero lt-header-overlay"
        style={{
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          height: '671px',
          marginTop: '106px',
          width: '100%',
        }}
      >
        {model.imagePath && (
          <img
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              zIndex: -3,
            }}
            className="hero-bg"
            src={model.imagePath}
            alt="Hero"
          />
        )}
        <video
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: -3,
          }}
          autoPlay
          muted
          loop
          width="100%"
          className="hero-bg"
          playsInline
        >
          <source src={model.videoPath} type="video/mp4" />
        </video>
        <div className="container" style={{ position: 'relative', zIndex: 1, padding: '40px 5px', width: '100%' }}>
          <div className="lt-hero-text" style={{ opacity: isFontLoaded ? 1 : 0, transition: 'opacity 0.2s ease-in' }}>
            <h1 className="lt-title-1" style={{ color: '#fff', marginBottom: '32px' }}>
              {model.title}
            </h1>
            {model.ctaText && (
              <>
                <a
                  href={model.ctaLink}
                  data-lity
                  className="button custom_click_track"
                  data-custom_click_track_value="Hero|Watch Video button|Button-Watch Video"
                  style={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }}
                  onClick={e => {
                    e.preventDefault();
                    setShowModal(true);
                  }}
                >
                  {model.ctaText || 'Watch Video'}{' '}
                  <Image src={playBtn} alt="Play" className="logo" width={17} height={17} />
                </a>
                {showModal && (
                  <VideoDialog isOpen={showModal} onClose={() => setShowModal(false)} videoUrl={model.ctaLink} />
                )}
              </>
            )}
          </div>
        </div>
      </section>
    </StyledHero>
  );
};

/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const LTHeroBanner = (props: any) => {
  const { model, ...restProps } = props;
  return (
    <EditableComponent {...restProps}>
      <div id="lt-hero" className="lt-hero-container">
        <HeroComp {...props} />
      </div>
    </EditableComponent>
  );
};
